module.exports = __webpack_public_path__ + "img/shift-icon-black.de546406.svg";